import React, {useEffect, useState} from 'react';
import moment from 'moment';
import './style.scss';
import LongTextTooltiper from "../../../Utils/LongTextTooltiper/LongTextTooltiper";

export default function OrderTime(props) {
    const [timeAgoText, setTimeAgoText] = useState();
    const [shouldBlink, setShouldBlink] = useState(false);

    const setTimeData = () => {
        setTimeAgoText(moment(new Date(props.time)).fromNow());
    };

    useEffect(() => {
        setTimeData();

        const timerId = setInterval(setTimeData, 20000);

        return () => {
            clearInterval(timerId);
        };
    }, [props.time, props.status]);

    return (
        <div className="order-time">
            <LongTextTooltiper backgroundColor="#efefef">
                {timeAgoText}
            </LongTextTooltiper>
        </div>
    );
}